import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import store from '../../store';
import { CHANGE_PAGE_action } from '../../store/actions/pageAction';
import { CREATE_EVENT_action } from '../../store/actions/eventAction';

// Componentes de UI
import { Button, Card, Avatar, ToggleButtonGroup, ToggleButton, Container } from '@mui/material';
import banner from "../../images/banner.png"


// Iconos
import { CiMenuBurger, CiStar, CiUser } from "react-icons/ci";
import { GoSearch } from "react-icons/go";
import { DatePicker, LocalizationProvider, MobileTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import Sidebar from '../../components/Sidebar';
import Header from '../../components/Header';
import Typography from '@mui/material/Typography';
import { styled, useTheme } from '@mui/material/styles';

import PropTypes from 'prop-types';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Skeleton from '@mui/material/Skeleton';
import SidebarResponsive from '../../components/SidebarResponsive';
import { useNavigate } from 'react-router-dom';

const mapStateToProps = (state) => {
    return {
        page: state.pageReducer.pageName,
        user: state.userReducer
    }
}

// COMPONENTES ESTILIZADOS
const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        flexGrow: 1,
        display: 'flex',
        flexWrap: 'wrap',
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: `-32px`,
        ...(open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
        }),
    }),
);


function Media(props) {
    const { loading = false } = props;

    return (
        <Card sx={{ maxWidth: 345, m: 2 }}>
            <CardHeader
                avatar={
                    loading ? (
                        <Skeleton animation="wave" variant="circular" width={40} height={40} />
                    ) : (
                        <Avatar
                            alt="Ted talk"
                            src="https://pbs.twimg.com/profile_images/877631054525472768/Xp5FAPD5_reasonably_small.jpg"
                        />
                    )
                }
                action={
                    loading ? null : (
                        <IconButton aria-label="settings">
                            <MoreVertIcon />
                        </IconButton>
                    )
                }
                title={
                    loading ? (
                        <Skeleton
                            animation="wave"
                            height={10}
                            width="80%"
                            style={{ marginBottom: 6 }}
                        />
                    ) : (
                        'Ted'
                    )
                }
                subheader={
                    loading ? (
                        <Skeleton animation="wave" height={10} width="40%" />
                    ) : (
                        '5 hours ago'
                    )
                }
            />
            {loading ? (
                <Skeleton sx={{ height: 190 }} animation="wave" variant="rectangular" />
            ) : (
                <CardMedia
                    component="img"
                    height="140"
                    image="https://pi.tedcdn.com/r/talkstar-photos.s3.amazonaws.com/uploads/72bda89f-9bbf-4685-910a-2f151c4f3a8a/NicolaSturgeon_2019T-embed.jpg?w=512"
                    alt="Nicola Sturgeon on a TED talk stage"
                />
            )}

            <CardContent>
                {loading ? (
                    <React.Fragment>
                        <Skeleton animation="wave" height={10} style={{ marginBottom: 6 }} />
                        <Skeleton animation="wave" height={10} width="80%" />
                    </React.Fragment>
                ) : (
                    <Typography variant="body2" color="text.secondary" component="p">
                        {
                            "Why First Minister of Scotland Nicola Sturgeon thinks GDP is the wrong measure of a country's success:"
                        }
                    </Typography>
                )}
            </CardContent>
        </Card>
    );
}

Media.propTypes = {
    loading: PropTypes.bool,
};


// MAIN
const Aceptados = () => {
    const [isLargeScreen, setIsLargeScreen] = useState(null); // Mide el tamaño de la pantalla para hacer el diseño responsive
    const navigate = useNavigate()

    useEffect(() => {
        const handleResize = () => {
            setIsLargeScreen(window.innerWidth >= 960); // set the breakpoint here
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div style={{ paddingLeft: 60, paddingRight: 64 }}>
            <Header></Header>
            <div style={{
                display: 'flex',
                width: '100%',
            }}>
                {isLargeScreen ? (<Sidebar></Sidebar>) : (<SidebarResponsive></SidebarResponsive>)}
                <div style={{ marginTop: (isLargeScreen && 'calc(70vh + 100px)') }}>
                    <Main style={{ display: 'flex', justifyContent: 'space-between' }}>
                        
                    </Main>
                </div>
            </div>
        </div>
    )

}

export default connect(mapStateToProps)(Aceptados);